import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import { ILead } from "../../models/BaseModel";
import { Fetch, ILazyParams } from "../../shared/Fetch";
import { IOpenForm } from "./Customer";
import { format } from "date-fns";
import { ConfirmDialog } from "primereact/confirmdialog";
import { Filter, IFilter } from "./Filter";
import { Tag } from "primereact/tag";
import { NoOfDevices } from "./NoofDevices";
import { NoOfPlans } from "./NoofPlans";
import { Tooltip } from "primereact/tooltip";
import { Toolbar } from "primereact/toolbar";
import { RenewPlan } from "./RenewPlan";
import { Dialog } from "primereact/dialog";
import { AccessoriesTable } from "./AccessoriesTable";

interface Iprops {
    setModal: (modal: IOpenForm) => void,
    toast: any,
    reload: boolean,
    reloadData: () => void,
    hasPermission: (pageName: string, featureName?: string) => boolean
}

export const Table = (props: Iprops) => {
    const [tableData, setTableData] = useState({ data: [], count: 0, loading: false, status: [] } as { data: ILead[], count: number, loading: boolean, status: { id: number, name: string, count: number }[] });
    const [tableData1, setTableData1] = useState({ data: [], loading: false } as { data: any[], loading: boolean });
    const [renewHistory, setRenewHistory] = useState({ customerDeviceID: 0, customer_name: "", open: false } as { customerDeviceID: number, open: boolean, customer_name: string });
    const [filter, setFilter] = useState<IFilter>({});
    const dt = useRef<any>(null);
    const [lazyParams, setLazyParams] = useState<ILazyParams>({
        first: 0,
        rows: 25,
        page: 1,
        sortField: 'id',
        sortOrder: -1
    });
    const [historyModal, setHistoryModal] = useState({ singleData: {}, open: false } as IOpenForm);
    const [showDevices, setShowDevices] = useState({ singleData: {}, open: false } as IOpenForm);
    const [showPlan, setShowPlan] = useState({ singleData: {}, open: false } as IOpenForm);
    const [selectedDevices, setSelectedDevice] = useState<any>();
    const [openRenewForm, setOpenRenewForm] = useState({ singleData: {}, open: false });
    const [openAccessories, setOpenAccessories] = useState({ singleData: {}, open: false } as IOpenForm);
    const [openAccesssoriesTable, setOpenAccesssoriesTable] = useState({ singleData: {}, open: false } as IOpenForm);

    const hideHistoryDialog = () => {
        setHistoryModal({ singleData: {}, open: false })
        setShowDevices({ singleData: {}, open: false })
        setShowPlan({ singleData: {}, open: false })
    };

    const showHistoryDialog = (rowData: ILead) => {
        setHistoryModal({ singleData: rowData, open: true })
        setShowDevices({ singleData: rowData, open: true })
    };
    const showPlanDialog = (rowData: ILead) => {
        setShowPlan({ singleData: rowData, open: true })
    };

    useEffect(() => {
        loadTableData();
    }, [lazyParams, filter, props.reload]);

    const onPage = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const onSort = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }
    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const loadTableData = async () => {
        setTableData((prev) => ({ ...prev, loading: true, }));
        let endpoint = "customer";
        if (filter.show_Customerwise === true) {
            endpoint = "customer/getCustmerwiseDetails";
        }
        const formattedFilter = {
            ...filter,
            fromDate: filter.fromDate ? format(new Date(filter.fromDate), 'yyyy-MM-dd') : undefined,
            toDate: filter.toDate ? format(new Date(filter.toDate), 'yyyy-MM-dd') : undefined,
        };

        const response = await Fetch(`${endpoint}`, "GET", null, `lazyParams=${JSON.stringify(lazyParams)}&filter=${JSON.stringify(formattedFilter)}`, props.toast);
        if (response) {
            const data: { leads: ILead[], count: number, status: { id: number, name: string, count: number }[] } = await response.json();
            setTableData({ data: data.leads, count: data.count, status: data.status, loading: false });
        } else {
            setTableData((prev) => ({ ...prev, loading: false, }));
        }
    }

    const showNoOFDevices = (rowData: any) => {
        return (
            <div className="flex align-items-center justify-content-center gap-2">
                <Tag className="p-button-sm p-button-rounded p-button-info" value={"See Devices"} severity="success" rounded onClick={() => showHistoryDialog(rowData)}></Tag>
                {/* <Button icon="pi pi-eye" className="p-button-sm p-button-rounded p-button-info" onClick={() => showHistoryDialog(rowData)} disabled={!props.hasPermission("Customer", "View")} /> */}
            </div>
        )
    }

    const showNoOfPlans = (rowData: any) => {
        return (
            <div className="flex align-items-center justify-content-center gap-2">
                <Tag className="p-button-sm p-button-rounded p-button-info" value={rowData.no_of_plans} severity="success" rounded onClick={() => showPlanDialog(rowData)}></Tag>
                {/* <Button icon="pi pi-eye" className="p-button-sm p-button-rounded p-button-info" onClick={() => showPlanDialog(rowData)} disabled={!props.hasPermission("Customer", "View")} /> */}
            </div>
        )
    }

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center gap-4">
            <div className="flex gap-4 w-full">

                <div className="w-full flex align-items-center justify-content-center">
                    <h4 style={{ margin: 0, textTransform: 'uppercase', fontFamily: 'Rancho', letterSpacing: 1 }}>Customer</h4>
                </div>
            </div>
            <div className="flex gap-4">
                {props.hasPermission("Customer", "Export") && (
                    <Button style={{ width: '80px', height: '30px' }} label="Export" icon="pi pi-upload" className="p-button-sm p-button-rounded p-button-help" onClick={exportCSV} />
                )}
            </div>
        </div>
    );

    const createdAtBody = (rowData: any) => {
        return (
            <span>{rowData.createdAt ? format(new Date(rowData.createdAt + "Z"), 'dd/MM/yyyy') : '-'}</span>
        );
    }

    const planDate = (rowData: any) => {
        return (
            <span>{rowData.expectedActivationDate ? format(new Date(rowData.expectedActivationDate), 'dd/MM/yyyy') : '-'}</span>
        );
    }

    const planstartDate = (rowData: any) => {
        return (
            <span>{rowData.plan_Start_Date ? format(new Date(rowData.plan_Start_Date), 'dd/MM/yyyy') : '-'}</span>
        );
    }

    const expirysDate = (rowData: any) => {
        return (
            <span>{rowData.plan_Expiry_Date ? format(new Date(rowData.plan_Expiry_Date), 'dd/MM/yyyy') : '-'}</span>
        );
    }

    const exprireAtBody = (rowData: any) => {
        return (
            <span>{rowData.expiryDate ? format(new Date(rowData.expiryDate), 'dd/MM/yyyy') : '-'}</span>
        );
    }


    //condition 1: plan expired if expired date is less than current date
    //condition 2: plan expired if days remaining is less than 0
    //condition 3: plan status is running if remaining days is greater than and equal to 15
    //condition 4: plan status about to expire if remaining days is less than 15
    // const planExpiredIn = (rowData: any) => {
    //     const days = rowData.days_remaining;

    //     let severity = 'info';
    //     let label = '-';

    //     if (days < 0) {
    //         severity = "danger";
    //         label = `Last Recharge ${days} Days ago`;
    //     } else if (days >= 15) {
    //         severity = "Info";
    //         label = `${days} Days `; // running
    //     } else if (days >= 0 && days < 15) {
    //         severity = "warning";
    //         label = `${days} Days`; // about to expire
    //     }

    //     return (
    //         <Tag
    //             className="custom-tag mr-2 text-sm"
    //             icon="pi pi-circle"
    //             severity={severity as "success" | "info" | "warning" | "danger"}
    //             value={label}
    //             style={{
    //                 width: '120px',
    //                 height: '32px',
    //                 display: 'flex',
    //                 alignItems: 'center',
    //                 justifyContent: 'center',
    //             }}
    //             data-pr-tooltip={`Status: ${label}`}
    //             data-pr-position="top"
    //         />
    //     );
    // };

    const planExpiredIn = (rowData: any) => {
        const days = rowData.daysRemaining;
        const eaDate = rowData.expectedActivationDate
            ? new Date(rowData.expectedActivationDate)
            : null;
        const today = new Date();

        let severity: "success" | "info" | "warning" | "danger" = "info";
        let label = "-";
        if (!eaDate || eaDate > today) {
            label = "Not Activated Yet";
        } else {
            if (days < 0) {
                severity = "danger";
                label = `Last Recharge ${Math.abs(days)} Days ago`;
            } else if (days >= 15) {
                severity = "info";
                label = `${days} Days`; // running
            } else if (days >= 0 && days < 15) {
                severity = "warning";
                label = `${days} Days`; // about to expire
            }
        }

        return (
            <Tag
                className="custom-tag mr-2 text-sm" icon="pi pi-circle" severity={severity} value={label} style={{ width: '150px', height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center', }}
                data-pr-tooltip={`Status: ${label}`}
                data-pr-position="top"
            />
        );
    };


    const rightToolbarTemplate = () => {
        return (
            <Button
                label="Renew"
                onClick={() => {
                    console.log(selectedDevices)
                    if (selectedDevices) {
                        setOpenRenewForm({ singleData: selectedDevices, open: true }); // Open bulk update modal
                    } else {
                        props.toast.current.show({ severity: 'warn', detail: 'Please select at least 1 device to updated plan.', life: 3000, });
                    }
                }}
            />
        );
    };

    const onHideRenewForm = () => {
        setOpenRenewForm({ singleData: {}, open: false });
        //  setSelectedDevice([]); // Clear selected devices after closing the modal
    };


    const showRenewHistoryDialog = (rowData: any) => {
        console.log(rowData.customer_Attach_Device_ID)
        setRenewHistory({ customerDeviceID: rowData.customerDeviceID, open: true, customer_name: rowData.contact_Person_Name });
    }

    const loadTableData1 = async () => {
        console.log(renewHistory.customerDeviceID)
        setTableData1((prev) => ({ ...prev, loading: true, }));
        const response = await Fetch(`customer/getPlanHistory${renewHistory.customerDeviceID ? '/' + renewHistory.customerDeviceID : ''}`, "GET", null, null, props.toast);
        if (response) {
            const data: { planistory: any[] } = await response.json();
            setTableData1({ data: data.planistory, loading: false });
        } else {
            setTableData1((prev) => ({ ...prev, loading: false, }));
        }
    }

    useEffect(() => {
        if (renewHistory.open) {
            loadTableData1();
        }
    }, [renewHistory.open]);

    const historyOfRenew = (rowData: any) => {
        return (
            <div className="flex align-items-center justify-content-center gap-2">
                <Button icon="pi pi-history" className="p-button-sm p-button-rounded p-button-info" onClick={() => showRenewHistoryDialog(rowData)} />
                {/* {rowData.isAccessorriesAdded && <Button icon="pi pi-box" className="p-button-sm p-button-rounded p-button-info" tooltip="See Accessories" tooltipOptions={{ position: 'top' }} onClick={() => showAccessoriesModal(rowData)} />} */}

                {/* <Button icon="pi pi-box" className="p-button-text p-0" style={{ color: '#6c63ff' }} tooltip="See Accessories" tooltipOptions={{ position: 'top' }} onClick={() => showAccessoriesModal(rowData)} /> */}

            </div>
        )
    }

    const showAccessoriesModal = (rowData: ILead) => {
        setOpenAccessories({ singleData: rowData, open: true });
    };

    const planstatusbackground = (rowData: any) => {
        const hexColor = rowData.plancolor?.startsWith('#') ? rowData.plancolor : `#${rowData.plancolor}`;
        const eaDate = rowData.expectedActivationDate
            ? new Date(rowData.expectedActivationDate)
            : null;
        const today = new Date();
        if (!eaDate || eaDate > today) {
            return (
                <span
                    style={{
                        //backgroundColor: hexColor,
                        //color: '#fff',
                        padding: '4px 8px',
                        borderRadius: '4px',
                        display: 'inline-block',
                        minWidth: '80px',
                        textAlign: 'center'
                    }}
                >
                    Not Activated
                </span>
            );
        }
        return (
            <span
                style={{ backgroundColor: hexColor, color: '#fff', padding: '4px 8px', borderRadius: '4px', display: 'inline-block', minWidth: '80px', textAlign: 'center' }} >
                {rowData.plan_status_label}
            </span>
        );
    };


    const loadAccessoriesBody = (rowData: any) => {
        return (
            <div className="flex align-items-center gap-2">
                <span style={{
                    color: rowData.isAccessoriesAdded ? '#4caf50' : '#f44336', textDecoration: 'underline', fontSize: '1.1rem', fontWeight: '500'
                }} onClick={() => {
                    rowData.isAccessoriesAdded ?
                        setOpenAccesssoriesTable({ singleData: rowData, open: true }) : setOpenAccesssoriesTable({ singleData: rowData, open: false });
                }}
                >{rowData.accessoriesCount}</span>
            </div >
        );
    }



    const copyToClipboard = async (value: any, type: any) => {
        if (!value) return;

        try {
            await navigator.clipboard.writeText(value);

            props.toast.current.show({
                severity: 'success',
                detail: `${type} copied successfully`,
                life: 1500
            });
        } catch (error) {
            console.error("Failed to copy:", error);
        }
    };


    const contactNumberBody = (rowData: ILead) => {
        return (
            <div className="flex align-items-center gap-2">
                <span>{rowData.contactContact || '-'}</span>

                {rowData.contactContact && (
                    <Button
                        icon="pi pi-copy"
                        className="p-button-text p-button-sm p-0"
                        tooltip="Copy contact number"
                        tooltipOptions={{ position: 'top' }}
                        onClick={() =>
                            copyToClipboard(
                                rowData.contactContact,
                                'Contact number'
                            )
                        }
                    />
                )}
            </div>
        );
    };


    const emailBody = (rowData: ILead) => {
        return (
            <div className="flex align-items-center gap-2">
                <span>{rowData.contactEmail || '-'}</span>

                {rowData.contactEmail && (
                    <Button
                        icon="pi pi-copy"
                        className="p-button-text p-button-sm p-0"
                        tooltip="Copy email"
                        tooltipOptions={{ position: 'top' }}
                        onClick={() =>
                            copyToClipboard(
                                rowData.contactEmail,
                                'Email'
                            )
                        }
                    />
                )}
            </div>
        );
    };


    const contactNameBody = (rowData: any) => {
        return (
            <div className="flex align-items-center gap-2">
                <span>{rowData.contact_Person_Name || '-'}</span>

                {rowData.contact_Person_Name && (
                    <Button
                        icon="pi pi-copy"
                        className="p-button-text p-button-sm p-0"
                        tooltip="Copy contact name"
                        tooltipOptions={{ position: 'top' }}
                        onClick={() =>
                            copyToClipboard(
                                rowData.contact_Person_Name,
                                'Contact name'
                            )
                        }
                    />
                )}
            </div>
        );
    };


    return (
        <>
            <Toolbar className="mb-1 py-0" right={rightToolbarTemplate}></Toolbar>
            <Filter header={
                <div className="flex align-items-center justify-content-end gap-4">
                    Filter
                    <div className="flex align-items-center justify-content-end gap-2 ml-auto">
                    </div></div>} loading={tableData.loading} hasPermission={props.hasPermission} filter={filter} setFilter={setFilter} />

            {filter.show_Customerwise ? (
                <DataTable className="no-copy-table" style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                    ref={dt} size="small" stripedRows showGridlines responsiveLayout="scroll" scrollHeight="70vh" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                    value={tableData.data} lazy dataKey="id"
                    paginator first={lazyParams.first} rows={lazyParams.rows} rowsPerPageOptions={[25, 50, 100, 200]}
                    totalRecords={tableData.count} onPage={onPage}
                    onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                    header={header}
                    loading={tableData.loading}>

                    <Column header="SN." body={(data, options) => options.rowIndex + 1} />
                    <Column field="contact_Person_Name" header="Customer" body={contactNameBody} />
                    <Column field="contactContact" header="Contact" body={contactNumberBody} />
                    <Column field="contactEmail" header="Email" body={emailBody} />
                    <Column field="planName" header="Running Plan" />
                    <Column field="no_of_devices" header="No.Of Device" body={showNoOFDevices} />
                    {/* <Column field="no_of_plans" header="No. Of Plan" body={showNoOfPlans} /> */}
                    <Column field="createdBy" header="CreatedBy" />
                    <Column field="created_At" header="Created At" sortable body={createdAtBody} />
                </DataTable>) : <DataTable className="no-copy-table" style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                    ref={dt} size="small" stripedRows showGridlines responsiveLayout="scroll" height="20vh" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                    value={tableData.data} lazy dataKey="customerDeviceID"
                    paginator first={lazyParams.first} rows={lazyParams.rows} rowsPerPageOptions={[25, 50, 100, 200]}
                    totalRecords={tableData.count} onPage={onPage}
                    onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                    header={header}
                    loading={tableData.loading}
                    selection={selectedDevices}
                    onSelectionChange={(e) => {
                        setSelectedDevice(e.value);
                    }} selectionMode="single" >
                {<Column selectionMode="single" />}
                <Column header="SN." body={(data, options) => options.rowIndex + 1} />
                <Column field="contact_Person_Name" header="Customer" body={contactNameBody} />
                <Column field="contactContact" header="Contact" body={contactNumberBody} />
                <Column field="contactEmail" header="Email" body={emailBody} />
                <Column field="assignedToSalesName" header="Sales Manager" />
                <Column field="deviceName" header="device" />
                <Column field="device_macAddress" header="Mac Address" />
                <Column field="planName" header="Plan Name" />
                <Column field="planDuration" header="Plan Duration" />
                <Column field="planCost" header="Plan Cost($)" />
                <Column field="days_remaining" header="Plan Expired In" body={planExpiredIn} />
                <Column field="plan_status_label" header="Plan Status" body={planstatusbackground} />
                {/* <Column field="no_of_devices" header="No.Of Device" body={showNoOFDevices} />
                <Column field="no_of_plans" header="No. Of Plan" body={showNoOfPlans} /> */}
                <Column field="deviceAddedBy" header="CreatedBy" />
                {/* <Column field="updatedBy" header="Updated By" /> */}
                <Column field="created_At" header="Created At" body={createdAtBody} />
                <Column field="expectedActivationDate" header="EA Date" body={planDate} />
                <Column field="expiry_date" header="Expired Date" body={exprireAtBody} />
                {/* <Column field="" header="Accessories" sortable body={loadAccessoriesBody} /> */}
                <Column field="" header="Action" body={historyOfRenew} ></Column>
            </DataTable>
            }
            <Tooltip target=".custom-tag" />
            <Tooltip target=".p-button" />
            <NoOfDevices singleData={showDevices.singleData} open={showDevices.open} hideDialog={hideHistoryDialog} toast={props.toast} hasPermission={props.hasPermission} />
            <NoOfPlans singleData={showPlan.singleData} open={showPlan.open} hideDialog={hideHistoryDialog} toast={props.toast} hasPermission={props.hasPermission} />
            <RenewPlan reloadData={props.reloadData} singleData={openRenewForm.singleData} tableData={selectedDevices} open={openRenewForm.open} hideDialoge={() => onHideRenewForm()} toast={props.toast} />
            <ConfirmDialog />
            <Dialog visible={renewHistory.open} style={{ width: '60vw' }} header={`Plan History of  | ${renewHistory.customer_name} |`} modal className="p-fluid" onHide={() => { setRenewHistory({ customerDeviceID: 0, open: false, customer_name: "" }) }}>
                <DataTable className="no-copy-table" style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                    size="small" stripedRows scrollHeight="50vh"
                    value={tableData1.data}
                    loading={tableData1.loading}
                >
                    <Column field="plan_Name" header="Plan Name" sortable></Column>
                    <Column field="plan_Duration" header="Duration" sortable></Column>
                    <Column field="plan_Cost" header="Cost" sortable></Column>
                    <Column field="plan_Start_Date" header="Plan Date" body={planstartDate} sortable></Column>
                    <Column field="plan_Expiry_Date" header="Expiry Date" body={expirysDate} sortable></Column>
                </DataTable>
            </Dialog>
            <AccessoriesTable hasPermission={props.hasPermission} singleData={openAccesssoriesTable.singleData} open={openAccesssoriesTable.open} hideDialog={() => setOpenAccesssoriesTable({ singleData: {}, open: false })} toast={props.toast} reloadData={props.reloadData} />

        </>
    );
}
